import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '@app/_services';
import { EndpointService } from '@app/endpoint/endpoint.service';
import { UserService } from '@app/user/user.service';
import { constants } from '@assets/data/constants';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-endpoint-edit-modal',
  templateUrl: './endpoint-edit-modal.component.html',
  styleUrls: ['./endpoint-edit-modal.component.less']
})
export class EndpointEditModalComponent implements OnInit {

  @ViewChild('ignoreModal', { static: false }) private content;
  @Input() endpointId: any;
  @Input() endpointType: any;
    createNewEndpointForm: FormGroup;
    myProjectsList: any = [];
    closeResult: string;
    duplicateEndpointData: any;
    bodyTypeEditOption: any;
    submitted: boolean = false;
    requestHeadersBulk = '';
    params: any = {};
    formParams: any = {};
    requestParamsBulk = '';
    bodyFormDataBulk = '';
    requestBodyBulk = '';
    bodyBulk = '';
    displayCURLInput = false;
    newCURLCommand: any;
    multipart: any = {};
    queryParams: any;
    isEndpointTypeReadonly = false;
    @Input() endpointDetails: any = {};
    webConfiguration: any;
    projectConfiguration: any;
    constants = constants;

    readonly BULK = 'bulk';
    readonly KEYVAL = 'keyval';
    readonly MULTIPART = 'multipart';
    readonly BINARY = 'binary';
    readonly RAW = 'raw';
    readonly FORMDATA = 'form-data';

    endPointTypes: any[] = [
      { name: 'REST', label: 'REST' },
      { name: 'SOAP', label: 'SOAP' },
      { name: 'WEB', label: 'WEB FLOW' },
      { name: 'MOBILE', label: 'MOBILE FLOW' },
      { name: 'DESKTOP', label: 'DESKTOP FLOW' },
    ];

    constructor(private formBuilder: FormBuilder,
      private toastr: ToastrService,
      private _commonServices: CommonService,
      private router: Router,
      private route: ActivatedRoute,
      private endpointService: EndpointService,
      private userService: UserService,
      public modalService: NgbModal,
      public modal: NgbActiveModal
    ) { }

    ngOnInit() {
      this.bodyTypeEditOption = this.FORMDATA;
      this.myProjects();
      this.setcreateNewEndpointForm();
      this.endpointDetails.id = this.endpointDetails.endPointId || this.endpointDetails.sqlId;
      this.getEndPointFlowById(this.endpointDetails.id);
      this.getPwProjectConfiguration(this.endpointDetails.id);
    }

    myProjects(): void {
      this._commonServices.getPwMyProjects().pipe().subscribe(data => {
        this.myProjectsList = data.response;
      });
    }

    setDefaultProject(projectId: any) {
      var selectedProject = this.myProjectsList.find((element) => {
        if(element.id === projectId) return element;
      });
      if(selectedProject) {
        this.createNewEndpointForm.get("project").setValue(selectedProject);
        this.getConfiguration(projectId);
      }
    }

    setcreateNewEndpointForm(): void {
      this.createNewEndpointForm = this.formBuilder.group({
        name: [null, [Validators.required]],
        project: [null, [Validators.required]],
        description: null,
        id: null,
        endPointType: ['REST'],
        subFlow: false,
        active: true,
        environmentSpecific: true,
        uri: [null, [Validators.required]],
        eventStreamTimeout: null,
        eventStreamInterruptKeyword: null,
        requestType: 'GET',
        threshold: null,
        keywords: [''],
        followRedirects: [true],
        sanitizeJsonResponse: [false],
        responseType: ['JSON', Validators.required],
        source: [],
        authorization: this.formBuilder.group({
          authorizationType: ['NONE', Validators.required],
          username: '',
          password: ''
        }),
        requestHeaders: {},
        requestParams: {},
        formParams: null, // form-data
        requestBody: null, // body raw format
        multiPartFormData: this.formBuilder.group({
          formDataParts: []
        }),
        binaryData: this.formBuilder.group({
          key: '',
          value: '',
          divideFileIntoChunks: [false],
          chunkSize: ''
        })
      });


      this.createNewEndpointForm.controls['endPointType'].valueChanges.subscribe(endPointType => {
        const endPointTypeLabel = endPointType.name || endPointType;
        if (endPointTypeLabel === 'MOBILE') {
          this.createNewEndpointForm.patchValue({ environmentSpecific: true, uri: 'MOBILEURI', requestType: 'NOT_APPLICABLE', subFlow: false });
          this.createNewEndpointForm.get('responseType').clearValidators();
        }
        else if (endPointTypeLabel === 'DESKTOP') {
          this.createNewEndpointForm.patchValue({ environmentSpecific: true, uri: 'DESKTOPURI', requestType: 'NOT_APPLICABLE', subFlow: false });
          this.createNewEndpointForm.get('responseType').clearValidators();
        }
        else if (endPointTypeLabel === 'WEB') {
          this.createNewEndpointForm.addControl('uri', new FormControl(null, [Validators.required]));
          this.createNewEndpointForm.patchValue({ environmentSpecific: true, uri: '', threshold: null, subFlow: false });
          this.createNewEndpointForm.get('responseType').clearValidators();
        }
        else if (endPointTypeLabel === 'REST' || endPointTypeLabel === 'SOAP') {
          this.createNewEndpointForm.patchValue({ environmentSpecific: true, requestType: 'GET', subFlow: false, uri: '' });
        }
      });


    }
    changeSubFlow(event: any) {
      let isSubFlow = event.target.checked;
      if (isSubFlow) {
        this.createNewEndpointForm.patchValue({ subFlow: true });
        if (this.createNewEndpointForm.value.endPointType.name === 'WEB') {
          this.createNewEndpointForm.removeControl('uri');
          this.createNewEndpointForm.removeControl('threshold');
        }
      } else {
        this.createNewEndpointForm.patchValue({ subFlow: false, environmentSpecific: true });
      }
    };
    showWebflow() {
      return this.createNewEndpointForm.value.endPointType === 'WEB' || this.createNewEndpointForm.value.endPointType === 'MOBILE' || this.createNewEndpointForm.value.endPointType === 'DESKTOP';
    }
    initializeEndPointTypes() {
      this.endPointTypes = [
        { name: 'REST', label: 'REST' },
        { name: 'SOAP', label: 'SOAP' },
        { name: 'WEB', label: 'WEB FLOW' },
        { name: 'MOBILE', label: 'MOBILE FLOW' },
        { name: 'DESKTOP', label: 'DESKTOP FLOW' },
      ];
    }

    getProjectConfiguration(event){
      if(event !== undefined && event !== null) {
        this.webConfiguration = event.webAutomationTool;
        if (event.webAutomationTool === 'PLAYWRIGHT' && !this.createNewEndpointForm.value?.id) {
          if(this.displayCURLInput){
            this.toastr.error('Playwright does not support import curl.');
            this.router.navigateByUrl('/endpoint/' + 'new')
                this.displayCURLInput = false;
          }
          this.endPointTypes = [{ name: 'REST', label: 'REST' },{ name: 'WEB', label: 'WEB FLOW' }]; //playwright
          this.createNewEndpointForm.patchValue({ endPointType: this.endPointTypes[0] });
          this.getConfiguration(event.id);
        } else if(event.webAutomationTool !== 'PLAYWRIGHT' && !this.createNewEndpointForm.value?.id){
          this.initializeEndPointTypes();
          this.getConfiguration(event.id)
        }
      } else {
        this.webConfiguration = null;
        this.initializeEndPointTypes();
      }
    }

    getConfiguration(projectId: number) {
      this.userService.getProjectConfiguration(projectId).subscribe((data) => {
        if (data.code == 200) {
          this.projectConfiguration = data.response;
          if(this.projectConfiguration.preferences !== null && this.projectConfiguration.preferences.endpointType !== null && this.projectConfiguration.preferences.endpointType !== undefined) {
            let selectedEndPointType = this.endPointTypes.filter(function(item) {
              if(item.name === data.response.preferences.endpointType) {
                return item
              }
            });
            this.createNewEndpointForm.get("endPointType").setValue(selectedEndPointType[0]);
          }
        } else {
          this.toastr.error(data.message);
        }
      });
    }

    getPwProjectConfiguration(id){
      this.endpointService.getProjectWebConfig(id).subscribe(data => {
        if (data.code === 200) {
         this.webConfiguration = data.response.WEB_AUTOMATION_TOOL;
        }
        else {
          this.toastr.error(data.message);
        }
      });
    }

    private getEndPointFlowById(id: number): void {
      this.isEndpointTypeReadonly = true;
      this.getPwProjectConfiguration(this.endpointDetails.id);
      this.endpointService.getEndpointById(id).subscribe(data => {
        if (data.code === 200) {
          if (data.response.endPointType === "WEB") {
            data.response['endPointType'] = { name: 'WEB', label: 'WEB FLOW' };
          }
          else if (data.response.endPointType === "DESKTOP") {
            data.response['endPointType'] = { name: 'DESKTOP', label: 'DESKTOP FLOW' };
          }
          else if (data.response.endPointType === "MOBILE") {
            data.response['endPointType'] = { name: 'MOBILE', label: 'MOBILE FLOW' };
          }
          else if (data.response.endPointType === "REST") {
            data.response['endPointType'] = { name: 'REST', label: 'REST' };
          } else if (data.response.endPointType === "SOAP") {
            data.response['endPointType'] = { name: 'SOAP', label: 'SOAP' };
          }
          this.createNewEndpointForm.patchValue({
            ...data.response,
            binaryData: data.binaryData || {},
            multiPartFormData: data.multiPartFormData || {}
          });
          if (data.response.subFlow && data.response.endPointType.name === "WEB") {
            this.createNewEndpointForm.removeControl('uri')
          }
          if (data.requestBody) { this.bodyTypeEditOption = this.RAW; }
          if (data.binaryData) { this.bodyTypeEditOption = this.BINARY; }
          if (data.multiPartFormData) { this.bodyTypeEditOption = this.MULTIPART; }
          this.setEndpointFormValues(this.endpointDetails);

        } else {
          this.toastr.error(data.message);
        }
      });
    }

    bodyTypeEditOptionGet(event) {
      this.bodyTypeEditOption = event;
    }
    get f() { return this.createNewEndpointForm.controls; }

    onSubmit(): void {
      this.submitted = true;
      if (this.createNewEndpointForm.invalid) {
        return;
      }
      const formValues = this.createNewEndpointForm.value;

      if (formValues.requestType === 'POST' || formValues.requestType === 'PUT' || formValues.requestType === 'PATCH' || formValues.requestType === 'DELETE') {
        const bodyTypeEditOption = this.bodyTypeEditOption?.toLowerCase();

        if (bodyTypeEditOption === this.FORMDATA) {
          formValues.requestBody = null;
          formValues.multiPartFormData = null;
          formValues.binaryData = null;
        } else if (bodyTypeEditOption === this.RAW) {
          formValues.multiPartFormData = null;
          formValues.formParams = null;
          formValues.binaryData = null;
        } else if (bodyTypeEditOption === this.MULTIPART) {
          formValues.requestBody = null;
          formValues.formParams = null;
          formValues.binaryData = null;
        } else if (bodyTypeEditOption === this.BINARY) {
          formValues.requestBody = null;
          formValues.formParams = null;
          formValues.multiPartFormData = null;
        }
      } else {
        formValues.requestBody = null;
        formValues.formParams = null;
        formValues.multiPartFormData = null;
        formValues.binaryData = null;
      }
      if(this.webConfiguration === 'PLAYWRIGHT'){
        formValues.multiPartFormData = null;
        formValues.binaryData = null;
      }

      this.setBulkDataToJson(formValues);

      if (formValues.multiPartFormData && formValues.multiPartFormData.formDataParts == null) {
        formValues.multiPartFormData.formDataParts = [];
      }
      if (this.createNewEndpointForm.value.id) {
        this.update(this.createNewEndpointForm.value);
      } else {
        this.save(this.createNewEndpointForm.value);
      }
    }

    save(formData: any, ignoreCreate?: any): void {
      let payload = { ...formData, endPointType: formData.endPointType.name || formData.endPointType };
      /* if subflow make status true */
      let forceCreate;
      if (formData.endPointType.name === "MOBILE" || formData.endPointType.name === "DESKTOP" || (formData.endPointType.name === 'WEB' && formData.subFlow)) {
        forceCreate = true;
      } else {
        forceCreate = ignoreCreate || false;
      }

      this.endpointService.save(payload, forceCreate).pipe().subscribe(data => {
        if (data.code === 200) {
          this.toastr.success(data.message);
          this.router.navigateByUrl('/endpoint/' + data.response.id);
        } else if (data.code === 409) {
          this.duplicateEndpointData = data.response;
          this.open(this.content);
        } else {
          this.toastr.error(data.message);
        }
      });
    }

    update(data: any): void {
      let payload = { ...data, endPointType: data.endPointType.name || data.endPointType };
      this.endpointService.update(payload).pipe().subscribe(data => {
        if (data.code === 200) {
          this.toastr.success(data.message);
          this.modal.close(true);
          // this.router.navigateByUrl('/endpoint/' + data.response.id);
        } else {
          this.toastr.error(data.message);
        }
      });
    }
    setBulkDataToJson(formValues) {
      if (this.requestHeadersBulk) { formValues.requestHeaders = JSON.parse(this.requestHeadersBulk); }
      if (this.requestParamsBulk) { formValues.requestParams = JSON.parse(this.requestParamsBulk); }
      if (this.bodyFormDataBulk) { formValues.formParams = JSON.parse(this.bodyFormDataBulk); }
    }


    private getEndpointById(data): void {
      if (data.endPointType === "WEB") {
        data['endPointType'] = { name: 'WEB', label: 'WEB FLOW' };
      }
      else if (data.endPointType === "DESKTOP") {
        data['endPointType'] = { name: 'DESKTOP', label: 'DESKTOP FLOW' };
      }
      else if (data.endPointType === "MOBILE") {
        data['endPointType'] = { name: 'MOBILE', label: 'MOBILE FLOW' };
      }
      else if (data.endPointType === "REST") {
        data['endPointType'] = { name: 'REST', label: 'REST' };
      } else if (data.endPointType === "SOAP") {
        data['endPointType'] = { name: 'SOAP', label: 'SOAP' };
      }
      this.createNewEndpointForm.patchValue({
        ...data,
        binaryData: data.binaryData || {},
        multiPartFormData: data.multiPartFormData || {}
      });
      if (data.subFlow && data.endPointType.name === "WEB") {
        this.createNewEndpointForm.removeControl('uri')
      }
      if (data.requestBody) { this.bodyTypeEditOption = this.RAW; }
      if (data.binaryData) { this.bodyTypeEditOption = this.BINARY; }
      if (data.multiPartFormData) { this.bodyTypeEditOption = this.MULTIPART; }
      this.setEndpointFormValues(data);
    }

    setEndpointFormValues(obj): void {
      // if (obj.requestParams != {}) { this.queryParamsInLine(obj.requestParams); }
    }

    ignoreCreate(data: any): void {
      this.save(data, true);
      this.modalService.dismissAll();
    }

    open(content: any): void {
      this.modalService.open(content, { windowClass: 'modal-holder', backdrop: 'static', size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }

    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }
    // getSelectedEndpointType(){
    //   if(!(this.createNewEndpointForm.value.endPointType === 'REST' || this.createNewEndpointForm.value.endPointType === 'SOAP' || this.createNewEndpointForm.value.endPointType.name === 'SOAP'|| this.createNewEndpointForm.value.endPointType.name === 'REST')){
    //     this.router.navigateByUrl('/endpoint/' + 'new')
    //     this.displayCURLInput = false;
    //   }
    // }
    updateBulkValue(data: any) {
      this.requestHeadersBulk = data;
    }
    updateRequestBulkValue(data: any) {
      this.requestParamsBulk = data;
    }
    updateBodyFormDataBulkValue(data: any) {
      this.bodyFormDataBulk = data;
    }

    ngOnDestroy(): void {
      this.modalService.dismissAll();
    }

  cancel() {
    this.modal.close(false);
  }
}
